var map = {
	"./components/Basket/en.json": 406,
	"./components/Basket/ru.json": 7264,
	"./components/Footer/en.json": 8857,
	"./components/Footer/ru.json": 971,
	"./components/Header/en.json": 7335,
	"./components/Header/ru.json": 1953,
	"./components/Product/en.json": 1197,
	"./components/Product/ru.json": 4263,
	"./components/ProductLightbox/en.json": 6042,
	"./components/ProductLightbox/ru.json": 5532,
	"./components/Result/en.json": 9967,
	"./components/Result/ru.json": 3129,
	"./components/TopNav/en.json": 6832,
	"./components/TopNav/ru.json": 3514,
	"./store/products/en.json": 7079,
	"./store/products/ru.json": 9921
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5432;